import { Navigate, Outlet } from 'react-router-dom';
import { Loading } from '@/components/ui/Loading';
import { useAuthStore } from '@/stores/authStore';

export function PublicRoute() {
  const { user, adminProfile, isLoading, isInitialized } = useAuthStore();

  if (!isInitialized || isLoading) {
    return <Loading fullScreen message="認証を確認しています..." />;
  }

  if (user && adminProfile) {
    return <Navigate to="/reviews/pending" replace />;
  }

  return <Outlet />;
}

